import { createSelector } from 'reselect'

const retailerIdSeatSelector = (state) =>
  (state.seats && state.seats.licenseSeatRetailerIds) || null
const seatSelector = (state) => (state.seats && state.seats.seats) || null
const seatCreateResponseSelector = (state) =>
  (state.seats && state.seats.create) || null
const seatDeleteResponseSelector = (state) =>
  (state.seats && state.seats.destroy) || null

export const selectRetailerSeatIds = createSelector(
  [retailerIdSeatSelector],
  (licenseSeatRetailerIds) => {
    return { licenseSeatRetailerIds }
  },
)

export const selectSeats = createSelector(
  [seatSelector],
  (seats) => {
    return { seats }
  },
)

export const selectSeatCreateResponse = createSelector(
  [seatCreateResponseSelector],
  (seatCreateResponse) => {
    return { seatCreateResponse }
  },
)

export const selectSeatDestroyResponse = createSelector(
  [seatDeleteResponseSelector],
  (seatDeleteResponse) => {
    return { seatDeleteResponse }
  },
)
